import { createStore as _createStore } from 'vuex'
import { setStore, getStore } from '@/utils/store'

export default _createStore({
  state: {
    tabActive: getStore({ name: 'tabActive' }) || '1',
    pressDetail: getStore({ name: 'pressDetail' }) || {},
    transitionMode: 'out-in',
    tabHref: getStore({ name: 'tabHref' }) || {},
    pressData: {},
  },
  getters: {
    tabActive: (state) => {
      return state.tabActive
    },
    pressDetail: (state) => {
      return state.pressDetail
    },
    pressData: (state) => {
      return state.pressData
    },
    tabHref: (state) => {
      return state.tabHref
    },
  },
  mutations: {
    setData(state, { name, value, store = false }) {
      if (store) {
        setStore({ name: name, content: value, type: 'session' })
      }
      state[name] = value
    },
  },
  actions: {},
  modules: {},
})
